export default __webpack_public_path__ + "static/media/cloture_2.c12fe420.png";